<template>
  <a class="text-16 text-blue"><slot /></a>
</template>

<script>
export default {
  name: 'SLink',
};
</script>
